<div class="sequence-table-container">
  <p-table [value]="sequences" [loading]="loading" styleClass="p-datatable-gridlines p-datatable-sm"
    [paginator]="true" [rows]="10">
    <ng-template pTemplate="header">
      <tr>
        <th>Sequence Name</th>
        <th>Status</th>
        <th>Prospects</th>
        <th>Opens</th>
        <th>Replies</th>
        
        <th>Created</th>
        <th>Actions</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-sequence>
      <tr>
        <td>{{sequence.name}}</td>
        <td>
          <p-tag [value]="sequence.status" [severity]="getSeverity(sequence.status)"></p-tag>
        </td>
        <td>{{sequence.prospects || sequence.metrics.totalProspects || 0}}</td>
        <td>{{sequence.opens || sequence.metrics.totalOpened || 0}}</td>
        <td>{{sequence.replies || sequence.metrics.totalReplied || 0}}</td>        
        <td>{{(sequence.createdDate ?? sequence.createdAt) | date:'MM-dd-yyyy'}}</td>
        <td>
          <div class="action-buttons">
            <button pButton pRipple icon="pi pi-play" class="p-button-outlined p-button-secondary p-button-rounded p-button-sm"
              (click)="onStartSequence(sequence)"
              *ngIf="canManageSequences && (sequence.status=='paused' || sequence.status=='draft' || sequence.status=='drafted' || sequence.status=='import prospects')"
              [pTooltip]="sequence.status=='import prospects'?'Import prospects to start campaign':'Start Sequence'"
              tooltipPosition="top" [disabled]="sequence.status=='import prospects'"></button>
            <button pButton pRipple icon="pi pi-pause" class="p-button-outlined p-button-secondary p-button-rounded p-button-sm"
              (click)="onPauseSequence(sequence)" *ngIf="canManageSequences && sequence.status=='active'" pTooltip="Pause Sequence"
              tooltipPosition="top"></button>
            <button pButton pRipple icon="pi pi-chart-bar" class="p-button-outlined p-button-secondary p-button-rounded p-button-sm"
              (click)="onViewMetrics(sequence)" pTooltip="View Metrics" tooltipPosition="top"></button>
            <button pButton pRipple icon="pi pi-eye" class="p-button-outlined p-button-secondary p-button-rounded p-button-sm"
              (click)="onViewDetails(sequence)" pTooltip="View Details" tooltipPosition="top"></button>
            <!-- Edit button - permission AND capability check -->
            <button pButton pRipple icon="pi pi-pencil" class="p-button-outlined p-button-secondary p-button-rounded p-button-sm"
              (click)="onEditSequence(sequence)"
              *appRequiresCapability="'sequence_management'; integration: selectedIntegration; mode: 'disable'"
              [disabled]="!canEditSequences"
              pTooltip="Edit Sequence" tooltipPosition="top"></button>
            <!-- Add prospects button - permission AND capability check -->
            <button pButton pRipple icon="pi pi-user-plus" class="p-button-outlined p-button-secondary p-button-rounded p-button-sm"
              pTooltip="Add Prospects to campaign to start" tooltipPosition="top"
              (click)="onShowProspectModal(sequence)"
              *appRequiresCapability="'sequence_management'; integration: selectedIntegration; mode: 'disable'"
              [disabled]="!canEditSequences || sequence.prospectList"
              [style.display]="(!sequence.prospectList || sequence.prospectList==null) ? 'inline-flex' : 'none'"></button>
            <!-- Delete button - permission AND capability check -->
            <button pButton pRipple icon="pi pi-trash" class="p-button-outlined p-button-secondary p-button-rounded p-button-sm"
              pTooltip="Delete Sequence" tooltipPosition="top"
              (click)="onDeleteSequence($event, sequence)"
              *appRequiresCapability="'sequence_management'; integration: selectedIntegration; mode: 'disable'"
              [disabled]="!canDeleteSequences"></button>
          </div>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="8" class="text-center">
          <div class="py-4">
            <i class="pi pi-list text-4xl text-color-secondary mb-3"></i>
            <p class="text-color-secondary">No email sequences found for {{currentCompany?.companyName || 'this company'}}.</p>
            <!-- Create button - permission AND capability check -->
            <button *ngIf="canEditSequences" pButton pRipple label="Create First Sequence" icon="pi pi-plus" class="p-button-primary mt-3"
              (click)="onNewSequenceClick($event)"
              appRequiresCapability="'sequence_management'"
              [appRequiresCapabilityIntegration]="selectedIntegration"
              [appRequiresCapabilityMode]="'disable'"
              [appRequiresCapabilityTooltip]="'This integration does not support creating sequences'"></button>
            <p *ngIf="!canEditSequences" class="text-color-secondary mt-3">Contact your administrator to create sequences.</p>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>